import { setTheme } from "theme/default/setTheme";

export const color_b7c8dc = setTheme(({ theme }) => theme.colors.color_b7c8dc);
